export const enum Orientation {
  Portrait = 'portrait',
  Landscape = 'landscape',
}
